import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { EguardValidationService } from './validation.service';

@Component({
    selector: 'eguard-validation-messages',
    templateUrl: './validation.component.html'
})
export class EguardValidationComponent {
    @Input() control: FormControl;
    constructor(private validationService: EguardValidationService) { }

    get errorMessage() {
        for (const propertyName in this.control.errors) {
            if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
                return EguardValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
            }
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/validation/validation.component.ts